import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {catchError, map} from "rxjs/operators";

@Injectable()
export class PrimeProjectResponseInterceptor implements HttpInterceptor {

  private readonly deServiceFieldsToReset: string[] = [
    "Documents", "ProjectCommonApproaches", "ProjectCurrencies", "ProjectLocations",
    "ProjectNafSources", "ProjectNonEvaluatedReasons", "ProjectProgrammeOffices", "ProjectRelatedProjects",
    "ProjectRoleAssignees", "ProjectSettlements", "ProjectThemes"];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isOnProjectOverviewScreen() && this.isDeServiceProjectGetRequest(req)) {
      return this.getModifiedResponseBody(req, next);
    }
    return next.handle(req);
  }

  private isOnProjectOverviewScreen() {
    return window.location.href.includes("ProjectOverview");
  }

  private isDeServiceProjectGetRequest(req: HttpRequest<any>) {
    return req.url.includes("deservice/v1/prime/entity/Project/instance/") && !req.params.has("isForWf");
  }

  private getModifiedResponseBody(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const body = JSON.parse(JSON.stringify(JSON.parse(req.body)));

    return next.handle(req)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (!(event instanceof HttpResponse)) return event;

          const modifiedBody = this.modifyResponseBody(event.body);
          event = event.clone({body: modifiedBody});
          return event;
        }),
        catchError((error, caught) => {
          console.log('Error Occurred');
          console.log(error);
          return Observable.throw(error);
        })
      );
  }

  private modifyResponseBody(responseBody: any): any {
    if (responseBody && responseBody.data) {
      this.deServiceFieldsToReset.forEach((fieldSystemName: string) => {
          if (responseBody.data[fieldSystemName] !== undefined) {
            responseBody.data[fieldSystemName] = [];
          }
        }
      );
    }
    return responseBody;
  }

}
